module.exports = __webpack_public_path__ + "img/guide_2_4.14c8c843.svg";